import { FaAngleUp } from 'react-icons/fa6';
import styled, { css } from 'styled-components';

import { Color } from '../../../shared/constants/Colors';
import { FontSize } from '../../../shared/constants/Fonts';
import { Typography } from '../../../shared/constants/Typographies';

export const NavSection = styled.div`
  padding: 2px 8px;
`;

export const StyledChevron = styled(FaAngleUp)`
  font-size: ${FontSize.XL};
  color: ${Color.CLOUD_BURST};
  padding: 5px;

  transition: transform 0.3s ease;

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: rotate(-180deg);
      color: ${Color.BLUE_RIBBON};
    `}
`;

export const NavTitle = styled.div`
  ${Typography.XXL_BOLDER};
  color: ${({ isOpen }) => (isOpen ? Color.BLUE_RIBBON : Color.CLOUD_BURST)};

  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  outline: none;
  user-select: none;
  padding: 15px 10px;

  &:hover {
    color: ${Color.BLUE_RIBBON};

    ${StyledChevron} {
      color: ${Color.BLUE_RIBBON};
    }
  }

  &:focus {
    outline: 2px solid ${Color.CLOUD_BURST};
    background-color: ${Color.WHISPER};
    border-radius: 4px;
  }

  &:focus:not(:focus-visible) {
    outline: none;
    background-color: transparent;
  }
`;

export const HorizontalLine = styled.span`
  border-bottom: 1px solid ${Color.MYSTIC};
  display: block;
  margin: 0 auto;
  width: 100%;
`;

export const Content = styled.div`
  max-height: ${({ expandedHeight }) => expandedHeight}px;
  overflow: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
  transition: max-height 0.3s ease, overflow 0.3s ease;

  ${({ isVisible }) =>
    !isVisible &&
    css`
      pointer-events: none;
      opacity: 0;
      visibility: hidden;
    `}
`;
